/**
 * @generated SignedSource<<c861168ad7bb608641d07332e2666d0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaWaitlistBodyFragment$data = {
  readonly agendas: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly facility: {
          readonly club: {
            readonly supportsPublic: boolean;
          } | null | undefined;
        };
        readonly id: string;
        readonly queueSlot: {
          readonly id: string;
        };
        readonly waitlistRestrictions: {
          readonly edges: ReadonlyArray<{
            readonly liftAt: string | null | undefined;
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"AgendaWaitlistBookings_Agenda">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AgendaWaitlistBodyFragment";
};
export type AgendaWaitlistBodyFragment$key = {
  readonly " $data"?: AgendaWaitlistBodyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaWaitlistBodyFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "courseIds"
    },
    {
      "kind": "RootArgument",
      "name": "date"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgendaWaitlistBodyFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "date"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "date"
        }
      ],
      "concreteType": "AgendaConnection",
      "kind": "LinkedField",
      "name": "agendas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AgendaWaitlistBookings_Agenda"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Club",
                      "kind": "LinkedField",
                      "name": "club",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "supportsPublic",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "waitlistRestrictions",
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "courseIds",
                      "variableName": "courseIds"
                    },
                    {
                      "kind": "Literal",
                      "name": "type",
                      "value": [
                        "WAITLIST"
                      ]
                    }
                  ],
                  "concreteType": "AgendaBookingRulesConnection",
                  "kind": "LinkedField",
                  "name": "bookingRules",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AgendaBookingRulesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "liftAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v1/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "QueueSlot",
                  "kind": "LinkedField",
                  "name": "queueSlot",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "20549b61018bd924392a5e1e41162335";

export default node;
